import { ContextValue } from "components/bookShuffle/useBookShuffle/types";
import useOwnsBook from "components/bookShuffle/useBookShuffle/hooks/useOwnsBook";
import useCurrentIndex from "components/bookShuffle/useBookShuffle/hooks/useCurrentIndex";
import useSkip from "components/bookShuffle/useBookShuffle/hooks/useSkip";
import useSetDecision from "components/bookShuffle/useBookShuffle/hooks/useSetDecision";

const methodHooks: { (context: ContextValue): void }[] = [
  useSetDecision,
  useCurrentIndex,
  useOwnsBook,
  useSkip,
];

export default methodHooks;
